import { BaseModel } from './base.model'
import { Center } from './center.model'
import { UserShiftSettings } from './user-shift-settings.model'
import { UserDecorator } from 'decorators'
import * as _ from 'lodash'
import { Constants } from 'config'
import { OnlineInterviewerShedule } from './online-interviewer-schedule/online-interviewer-schedule.model'

export class User extends BaseModel<User> {
  static DEFAULT_ATTRIBUTES = {
    activatedDevicesLimit: 0,
    deviceActivationsCount: 0,
    centers: [],
    centerIds: [],
    roles: [],
    interviewerCenter: [],
    interviewerCenterIds: []
  }

  activatedDevicesLimit: number
  deviceActivationsCount: number
  email: string
  firstname: string
  id: number
  lastname: string
  password: string
  phone: string
  roles: string[]
  state: string
  centerIds: number[] = []
  centers: Center[]
  interviewerCenterIds: number[] = []
  interviewerCenters: Center[]
  shiftSettings: UserShiftSettings
  permissions: string[]
  schedule: OnlineInterviewerShedule

  protected decorator: UserDecorator

  constructor(attributes: Object) {
    super(attributes)

    if (this.centers) {
      this.centerIds = this.centers.map(c => c.id)
    }

    if (this.interviewerCenters) {
      this.interviewerCenterIds = this.interviewerCenters.map(c => c.id)
    }
  }

  get fullname(): string {
    return this.lastname + ' ' + this.firstname
  }

  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }

  hasRole(role:string):boolean {
    return this.roles.indexOf(role) >= 0
  }

  hasAnyOfRoles(roles:string[]):boolean {
    return _.intersection(this.roles, _.flatten(roles)).length >= 0
  }


  isWebUser(): boolean {
    return this.hasAnyOfRoles(Constants.USERS.WEB_ROLES)
  }

  isAdmin(): boolean {
    return this.hasRole('admin')
  }

  isAccessor(): boolean {
    return this.hasRole('accessor')
  }

  isVideoAccessor(): boolean {
    return this.hasRole('video_accessor')
  }

  isCenterMember(): boolean {
    return this.hasRole('center_member')
  }

  isContentEditor(): boolean {
    return this.hasRole('content_editor')
  }

  isPhoneController(): boolean {
    return this.hasRole('phone_controller')
  }

  isModerator(): boolean {
    return this.hasRole('moderator')
  }

  isTechnician(): boolean {
    return this.hasRole('technician')
  }

  isInterviewer(): boolean {
    return this.hasRole('interviewer')
  }

  isOnlineInterviewer(): boolean {
    return this.hasRole('online_interviewer')
  }

  isSupport(): boolean {
    return this.hasRole('support')
  }

  isHubCoordinator(): boolean {
    return this.hasRole('hub_coordinator')
  }

  decorate(): UserDecorator {
    if(!this.decorator) { this.decorator = new UserDecorator(this) }
    return this.decorator
  }

  can(permissions: string[]): boolean {
    permissions.push("manage:all")
    return this.permissions.filter(p => permissions.indexOf(p) > -1).length > 0
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/user.model.ts